// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__17YVa","footer":"ModalInfo_footer__-GT5M"};